{
  "topMenu": {
    "dihTitle": "データインテリジェンスハブ",
    "dihSubTitle": "データから安全に価値を抽出",
    "logout": "ログアウト"
  },
  "userLogoutAlert": {
    "title": "本当にログアウトしますか？",
    "back": "戻る",
    "logout": "ログアウト"
  },
  "sideMenu": {
    "home": "ホーム",
    "collapse": "サイドバーを折りたたむ",
    "help": "ヘルプ",
    "prepare": "モデル管理",
    "model": "データモデル",
    "mapping": "データマッピング",
    "converter": "データコンバーター",
    "provide": "提供",
    "publishData": "データ公開",
    "assets": "アセット",
    "policyPublicationTemplate": "ポリシー公開テンプレート",
    "uploadHistory": "アセットアップロード履歴",
    "consume": "消費",
    "searchDataOffers": "データオファー検索",
    "negotiatedDataOffers": "交渉済みデータオファー",
    "downloadHistory": "アセットダウンロード履歴",
    "govern": "ガバナンス",
    "myPolicies": "マイポリシー",
    "createPolicies": "ポリシー作成",
    "policyTemplate": "ポリシーテンプレート",
    "manageAndConfig": "設定",
    "connections": "コネクター管理",
    "jobs": "処理ログ",
    "monitoring": "モニタリング",
    "licences": "ライセンス",
    "contractDefinitions": "契約定義",
    "providedAgreements": "提供契約合意",
    "incomingAgreements": "受信データオファー",
    "consumedAgreements": "消費契約合意",
    "consumeAutomation": "消費ポリシー自動化",
    "networkAnalytics": "ネットワーク分析",
    "otherLogs": "その他のログ",
    "digitalTwin": "デジタルツインブラウザ",
    "messagesBrowserInbound": "受信メッセージ",
    "messagesBrowserOutbound": "送信メッセージ",
    "applications": "アプリケーション",
    "pcfExchange": "PCF交換",
    "pcfRequests": "PCFデータリクエスト",
    "pcfExchangeHistory": "PCFデータ交換履歴",
    "publicationTemplates": "公開テンプレート",
    "certificateManagement": "証明書管理"
  },
  "dropdown": {
    "selectAll": "すべて選択",
    "noOption": "利用可能なオプションがありません",
    "noSuchOption": "そのようなオプションはありません...",
    "selectConnection": "接続を選択"
  },
  "certificateManagement": {
    "title": "ビジネスパートナー証明書管理",
    "description": "Catena-X の使いやすいエンドツーエンドのビジネスパートナー証明書交換ソリューションへようこそ。",
    "howTo": {
      "description": "他の Catena-X メンバー企業のデータ提供カタログを確認できます。証明書の提供を検索、選択、購読することが可能です。会社名で検索することもできます。",
      "doc": "ビジネスパートナー証明書管理の仕組みについてもっと知りたいですか？"
    },
    "landingTiles": {
      "tile_1": {
        "title": "証明書を共有",
        "description": "Catena-X ネットワークでサイト証明書を作成・共有しましょう。"
      },
      "tile_2": {
        "title": "証明書を探す",
        "description": "サイトおよびビジネス証明書を簡単に検索してダウンロードできます。"
      },
      "tile_3": {
        "title": "証明書交換履歴",
        "description": "交換履歴がすぐに確認できます。"
      },
      "tile_4": {
        "title": "証明書をリクエスト",
        "description": "サイトおよびビジネス証明書を簡単に検索してダウンロードできます。"
      }
    },
    "recentCertificateRequests": "最近の証明書リクエスト",
    "learnMore": "証明書管理について詳しく知る"
  },
  "common": {
    "start": "開始",
    "firstName": "名",
    "lastName": "姓",
    "email": "メールアドレス",
    "phoneNumber": "電話番号",
    "contactPerson": "連絡担当者",
    "welcome": "ようこそ",
    "street": "住所",
    "city": "都市",
    "country": "国",
    "postCode": "郵便番号",
    "number": "番号",
    "next": "次へ",
    "prev": "戻る",
    "alreadyAccount": "すでにアカウントをお持ちですか？",
    "login": "ログイン",
    "loginNow": "今すぐログイン",
    "register": "登録",
    "home": "ホーム",
    "submit": "送信",
    "attention": "注意",
    "desc": "説明",
    "website": "ウェブサイト",
    "contact": "連絡先",
    "details": "詳細",
    "plan": "プラン",
    "listView": "リストビュー",
    "gridView": "グリッドビュー",
    "firstPage": "最初のページへ",
    "previousPage": "前のページへ",
    "nextPage": "次のページへ",
    "lastPage": "最後のページへ",
    "paginationUnknownButton": "不明なページネーションボタンタイプ",
    "download": "ダウンロード",
    "delete": "削除",
    "edit": "編集",
    "information": "情報",
    "organization": "組織",
    "cancel": "キャンセル",
    "save": "保存",
    "upload": "アップロード",
    "link": "リンク",
    "view": "表示",
    "search": "検索",
    "searchTerm": "検索",
    "selectOption": "オプションを選択",
    "sortBy": "並べ替え",
    "dataspace": "データスペース",
    "select": "選択",
    "date": "日付",
    "title": "タイトル",
    "back": "戻る",
    "startTyping": "入力開始",
    "useCases": "ユースケース",
    "done": "完了",
    "enterValue": "値を入力",
    "selectValue": "値を選択",
    "selectDate": "日付を選択",
    "refresh": "更新",
    "searchByName": "名前で検索",
    "close": "閉じる",
    "copyToClipboard": "クリップボードにコピーしました！",
    "enterKeyName": "キー名を入力"
  },
  "genericError": "おっと、何か問題が発生しました！もう一度お試しください。",
  "validation": {
    "fieldRequired": "{field} は必須です。",
    "fieldNumeric": "フィールド {field} には数字のみを含めることができます。",
    "fieldAlpha": "フィールド {field} には文字、_、- のみを含めることができます。",
    "fieldAlphanumeric": "フィールド {field} には文字、数字、_、- のみを含めることができます。",
    "fieldNumericDash": "フィールド {field} には数字と - のみを含めることができます。",
    "fieldHouseNumber": "フィールド {field} には数字、文字、-、/ のみを含めることができます。",
    "fieldPhoneNumber": "フィールド {field} には数字と - のみを含め、+ または 00 で始まる必要があります。",
    "fieldAlphaDash": "フィールド {field} には文字と - のみを含めることができます。",
    "exceptHTMLTagBrackets": "フィールド {field} には次の文字を含めることはできません：^<>",
    "isMaxLength": "最大長10文字を超えています。",
    "emailFormat": "メールアドレスの形式が正しくありません",
    "fileSizeError": "ファイルサイズが {size} MB を超えています。",
    "csvFileSizeError": "ファイルが大きすぎます。最大 {size} MB のファイルをアップロードできます。",
    "csvFileExtensionError": "csv 拡張子のファイルのみ許可されています。",
    "csvFileIsEmptyError": "ファイルが空です。少なくとも {size} KB のファイルをアップロードする必要があります。",
    "csvFileFormatError": "ファイルの形式が期待される形式と一致しません。提供されたテンプレートを使用して再度お試しください。",
    "uploadFails": "アップロードに失敗しました",
    "fileExtensionError": "ファイルの拡張子が適切ではありません",
    "fileIsMalwareInfectedError": "このファイルにはマルウェアが含まれている可能性があります。セキュリティ上の理由から、このファイルはアップロードできません。ファイルを確認してください。",
    "customValidation": "{field} の形式が正しくありません。",
    "selectCountryFirst": "まず国名を選択してください",
    "validationPostCodeCaseDE": "フィールドの形式が正しくありません。5桁の数字（例：53113）でなければなりません",
    "validationAlphanumericCase": "フィールドには英数字、ダッシュ、アンダースコアのみを含めることができます。値は英数字で始まる必要があります。",
    "validationNumericDashCase": "フィールドには数字と - のみを含めることができます。",
    "url": "有効なURLを入力してください",
    "required": "このフィールドは必須です",
    "password": {
      "passwordStrength": "パスワードの強度",
      "weak": "弱い",
      "average": "平均",
      "strong": "強い",
      "passwordValidationMoreChar": "{count} 文字以上",
      "passwordUpperAndLowerChar": "大文字と小文字",
      "passwordAtLeastNumber": "少なくとも1つの数字",
      "passwordAtLeastSpecialChar": "少なくとも1つの特殊文字（<>&\"`[] 以外）",
      "passwordDiffFromPrev": "以前のパスワードと異なる"
    }
  },
  "footer": {
    "tagLine": "より高いパフォーマンスを支えよう",
    "imprint": "法的通知",
    "imprintShort": "通知",
    "imprintLink": "https://dih.telekom.com/en/imprint",
    "contact": "お問い合わせ",
    "contactLink": "https://dih.telekom.com/en/contact",
    "termsAndConditions": "利用規約",
    "privacy": "プライバシーポリシー",
    "privacyShort": "プライバシー",
    "telekom": "T-Systems International GmbH。全権利を保有。",
    "telekomShort": "T-Systems International GmbH",
    "note": "テレコムデータインテリジェンスハブ - ビジネス顧客専用",
    "brandedNote": "テレコムデータインテリジェンスハブ提供",
    "help": "ヘルプ",
    "cookieSettings": "クッキー設定",
    "cookieSettingsShort": "クッキー",
    "life": "人生は共有のためにある"
  },
  "cookieSettings": {
    "collapsedTitle": "プライバシー設定",
    "collapsedText": "このウェブサイトはクッキーおよび類似の技術を使用しています。これらはコンピュータに保存され、読み取られる小さなテキストファイルです。「{0}」をクリックすることで、処理、ウェブサイトやパートナー間での個別ユーザー情報の作成、EU外（GDPR 第49条）の第三者へのデータ転送に同意します。詳細は{1}のセクション2を参照してください。データは分析、リターゲティング、テレコムサイトおよび第三者サイトでのパーソナライズされたコンテンツや広告の表示に使用されます。第三者プロバイダによるデータ処理や取り消しの可能性を含む詳細情報は、設定およびプライバシー情報に記載されています。ここでは{2}必要なツールのみで続行できます。",
    "extendedTitle": "プライバシー設定",
    "extendedText": "最適なウェブサイト体験を提供するため、クッキーを使用しています。これには、サイトの運用や最適化のためのクッキー、テキストやビデオチャットなどのサービス、オンライン利用行動に基づく広告のためのクッキーが含まれます。例えば、同じデバイスからの繰り返し訪問を検出できます。どのクッキーを許可するかを選択できます：",
    "policyLinkHref": "https://dih.telekom.com/en/privacy-policy",
    "policyLinkCookieHref": "https://dih.telekom.com/en/privacy-policy",
    "policyLinkTextShort": "プライバシー情報",
    "policyLinkText": "プライバシー情報",
    "rejectLinkText": "続行",
    "acceptButton": "すべて受け入れる",
    "saveButton": "設定を保存",
    "settingsButton": "設定を変更",
    "showMore": "もっと表示",
    "showLess": "表示を減らす",
    "categoryTitleEssential": "必須クッキー",
    "categoryTitleAnalytics": "分析クッキー",
    "categoryTitleMarketing": "マーケティングクッキー",
    "categoryTitleThirdParty": "他社によるサービス（独立した第三者プロバイダ）",
    "categoryTextEssential": "これらのクッキーは、ウェブサイトを閲覧し、主要な機能を使用するために必要です。オンラインショップの注文処理やウェブページのセキュリティエリアへのアクセスなどの基本機能をサポートします。また、ユーザーパターンの匿名分析を行い、ウェブページの継続的な開発と改善に使用します。",
    "categoryTextAnalytics": "これらのクッキーは、ユーザー行動の理解を向上させるのに役立ちます。分析クッキーは、元のプロバイダまたは第三者プロバイダによる使用および識別データの収集を、匿名使用プロファイルにまとめることを可能にします。分析クッキーは、例えば、ウェブページやサービスの個々の訪問者数を把握し、製品のパフォーマンスに関する統計データを収集し、匿名および仮名情報に基づく訪問者の使用パターンと対話を分析するために使用されます。この情報は個人に遡及できません。",
    "categoryTextMarketing": "これらのクッキーおよび類似の技術は、パーソナライズされた、したがって関連性の高いマーケティングコンテンツの表示を可能にするために使用されます。マーケティングクッキーは、興味深い広告コンテンツを表示し、キャンペーンの効果を測定するために使用されます。これはテレコムのウェブサイトだけでなく、他の広告パートナーサイト（第三者プロバイダ）でも行われます。これはリターゲティングとも呼ばれ、仮名コンテンツや広告プロファイルを作成し、他のウェブサイトで関連広告を配置し、広告やコンテンツを閲覧したターゲットグループの洞察を導出するために使用されます。この情報は個人に遡及できません。マーケティングおよびリターゲティングツールは、関連性の高い広告コンテンツを提供するのに役立ちます。マーケティングクッキーを抑制しても、広告の表示量は変わりませんが、関連性が低くなる可能性があります。",
    "categoryTextThirdParty": "テレコムのウェブサイトには、独自の責任でサービスを提供する第三者サービスプロバイダへのリンクが含まれています。テレコムのウェブページを訪問すると、クッキーまたは類似の技術がデータを記録し、テレコム自身の目的のために一部を第三者に送信します。第三者自身の目的での処理の範囲、目的、法的根拠は、第三者のデータプライバシー情報で確認できます。独立した第三者プロバイダに関する情報は、データプライバシー情報で確認できます。"
  },
  "messages": {
    "noDataAvailable": "データがありません",
    "noMatchFound": "一致するものが見つかりません",
    "maximumFileSize": "最大ファイルサイズ",
    "suitableFileFormats": "適切なファイル形式",
    "loading": "読み込み中...",
    "dragDropText": "またはここにドラッグ＆ドロップ",
    "noConnectors": "コネクターが見つかりません！",
    "comingSoon": "近日公開"
  },
  "pageNotFound": {
    "title": "おっと！お探しのページはまだ存在しません。",
    "subtitle": "その間に、他の役立つリソースをご覧ください！"
  },
  "helpResources": {
    "needHelp": "適切なプランの選択、詳細情報、技術的な質問にお困りですか？",
    "developerDoc": "インテグレーター向けドキュメント",
    "developerDocDesc": "APIドキュメントを取得して開始",
    "example": "例",
    "tutorials": "チュートリアル",
    "exampleDescription": "あなたの産業分野に関連するユースケースやデモを見つける",
    "FAQ": "よくある質問",
    "FAQDescription": "請求からプライバシーまで、よくある質問の回答を見つける",
    "browse": "閲覧",
    "demos": "デモ",
    "demosDescription": "あなたの産業分野に関連するユースケースやデモを見つける",
    "glossary": "用語集",
    "glossaryDescription": "データインテリジェンスハブ、IDSA、Catena-X、Gaia-Xなどに関連する用語と定義を見つける。",
    "contactUs": "この機能は現在のサブスクリプションではサポートされていません。アップグレードするにはお問い合わせください。"
  },
  "feedbackCard": {
    "title": "さらにヘルプが必要ですか？",
    "contactUs": "お問い合わせ"
  },
  "error": {
    "pageNotFound": "ページが見つかりません (404)",
    "somethingWrong": "何か問題が発生しました！",
    "propertyNotFound": "プロパティが見つかりません",
    "uniquePropertyName": "プロパティ名は一意でなければなりません",
    "dctTypeNotFound": "dct:type が見つかりません"
  },
  "helpWidget": {
    "askSupport": "サポートに問い合わせる",
    "chatboxTitle": "ヘルプチャット",
    "chatboxSubtitle": "テレコムデータインテリジェンスハブサポート",
    "defaultMessage": {
      "body": "こんにちは、テレコムデータインテリジェンスハブのサポートチャンネルへようこそ。以下のオプションを選択してください。"
    },
    "whatCanWeHelpWith": "今日、どのようなお手伝いが必要ですか？",
    "suggestedAnswers": {
      "knowledgeBase": "ナレッジベース、ドキュメント、FAQ",
      "contactSupport": "サポートに連絡",
      "contactSales": "セールスに連絡"
    }
  },
  "pcfExchange": {
    "title": "PCF交換",
    "description": "Catena-Xにおける使いやすいエンドツーエンドの製品カーボンフットプリント（PCF）交換ソリューションへようこそ。",
    "recentRequests": "最近のPCFデータリクエスト",
    "viewAllRequests": "すべてのリクエストを表示",
    "requestPcf": "PCFをリクエスト",
    "termCheck": "リクエストを送信することで、データ提供者が設定したポリシーに基づいて契約が交渉されることを理解します。",
    "pcfSuccess": "PCFのリクエストが成功しました！",
    "landing": {
      "pcfTitle": "PCFオファー作成",
      "pcfDesc": "Catena-Xネットワーク内でPCFデータを作成し、参加者と共有。",
      "discoverTitle": "PCFデータの検索とリクエスト",
      "discoverDesc": "Catena-Xネットワーク内でPCFデータを簡単に検索するか、簡単な手順でパートナーからPCFデータをリクエスト。",
      "pcfReqTitle": "PCFデータリクエスト",
      "pcfReqDesc": "Catena-Xネットワーク内でのパートナーからのPCFデータリクエストを効率的に管理。",
      "pcfCalcTitle": "PCF計算機",
      "pcfCalcDesc": "PCF値を計算し、アプリケーションやPCFデータ交換シナリオにシームレスに接続。",
      "pcfHistoryTitle": "PCFデータ交換履歴",
      "pcfHistoryDesc": "Catena-XネットワークおよびパートナーでのPCFデータ交換履歴の透明性を確保。",
      "documentation": "PCFデータ交換について学ぶ",
      "howTo": {
        "description": "Catena-X内で製品カーボンフットプリント（PCF）データオファーを共有、発見、管理。",
        "doc": "接続と統合についてもっと知りたい？ドキュメントリンク："
      }
    },
    "requests": {
      "pcfRequests": "PCFデータリクエスト",
      "reqDesc": "このエリアを使用して、パートナーからのPCFデータリクエストを管理。",
      "productId": "製品ID*",
      "bpn": "BPN*",
      "message": "メッセージ",
      "howTo": {
        "title": "PCFデータリクエスト管理についてもっと知りたい？",
        "description": "このセクションを使用して、パートナーからのPCFデータリクエストを承認または拒否。さらに、PCFデータ交換の状態を確認し、PCFデータチェーンで完全な透明性を確保。",
        "doc": "データオファー交渉と消費の仕組みについてもっと知りたい？"
      }
    },
    "responses": {
      "howTo": {
        "description": "他のCatena-Xメンバー企業のデータオファーカタログを発見。データオファーを検索、選択、購読できます。会社名、製造者部品ID、またはその両方の組み合わせでデータオファーを検索できます。"
      }
    },
    "view": { "title": "PCF詳細を表示" }
  },
  "publicationTemplates": {
    "title": "マイ公開テンプレート",
    "deletedTemplates": "マイ削除済みテンプレート",
    "showDeletedTemplates": "削除済みテンプレートを表示",
    "hideDeletedTemplates": "アクティブなテンプレートを表示",
    "newTemplate": "新規テンプレート",
    "create": {
      "title": "公開テンプレート作成",
      "edit": "公開テンプレート編集",
      "templateName": "テンプレート名",
      "templateType": "{type} テンプレート",
      "create": "作成",
      "update": "更新",
      "name": "名前",
      "createdAt": "作成日",
      "modifiedAt": "修正日",
      "country": "国",
      "accessPolicyId": "アクセスポリシー",
      "usagePolicyId": "使用ポリシー",
      "id": "ID",
      "createdBy": "作成者",
      "modifiedBy": "修正者",
      "isEnabled": "有効",
      "targetCompany": "対象企業",
      "targetConnectors": "対象コネクター",
      "selectCountry": "国を選択",
      "templateDetails": "公開テンプレート詳細",
      "assetsCriteria": "アセット選択基準",
      "connectorDetails": "コネクター詳細"
    },
    "delete": {
      "title": "公開テンプレート削除",
      "description": "このテンプレートを削除しますか？",
      "button": "削除"
    }
  },
  "contracts": {
    "title": "契約合意詳細",
    "provider": {
      "description": "これはあなたの組織が他のデータスペース参加者と結んだ契約合意の概要です。",
      "howItWorks": {
        "description": "ここでは、さまざまなデータスペースにわたる購読または交渉済みのデータ合意をすべて確認できます。特定のコネクターで結果をフィルタリングしたり、契約合意IDまたはアセットIDで検索できます。必要に応じてリストを並べ替えることもできます。さらに、データオファーを選択してローカルにエクスポートできます。",
        "subtitle": "データオファー交渉と消費の仕組みについてもっと知りたい？"
      },
      "details": {
        "title": "提供契約合意詳細",
        "description": "説明",
        "content": "内容",
        "agreementDetails": "合意詳細",
        "assetDetails": "アセット詳細",
        "usagePolicy": "使用ポリシー"
      }
    },
    "consumer": {
      "description": "これはあなたの組織が他のデータスペース参加者のデータオファーに対して結んだ契約合意の概要です。",
      "downloadData": "データダウンロード",
      "downloadAgreement": "合意ダウンロード",
      "reinitiate": "転送開始＆データダウンロード",
      "error": {
        "heading": "申し訳ありません！この契約はすでに交渉済みです。",
        "body": "交渉済みの契約を再交渉することはできません。契約の詳細は以下で確認でき、合意をダウンロードしてデータを購読できます。"
      },
      "details": {
        "title": "消費契約合意詳細"
      },
      "howItWorks": {
        "description": "ここでは、さまざまなデータスペースにわたる購読または交渉済みのデータ合意をすべて確認できます。特定のコネクターで結果をフィルタリングしたり、契約合意IDまたはアセットIDで検索できます。必要に応じてリストを並べ替えることもできます。さらに、データオファーを選択してローカルにエクスポートできます。",
        "subtitle": "データオファー交渉と消費の仕組みについてもっと知りたい？"
      }
    }
  },
  "provider": {
    "provider": "提供者",
    "assets": {
      "title": "マイアセット",
      "offeredBy": "提供者：",
      "offers": "オファー",
      "created": "作成日",
      "modifiedAt": "修正日",
      "noResultsFound": "アセットが見つかりませんでした",
      "success": "アセット作成に成功",
      "updateSuccess": "アセット更新に成功",
      "buttons": {
        "createOffer": "オファー作成",
        "details": "詳細を表示",
        "delete": "アセット削除",
        "create": "アセット作成",
        "close": "閉じる",
        "edit": "アセット編集",
        "update": "アセット更新",
        "showDeleted": "削除済みアセットを表示",
        "hideDeleted": "削除済みアセットを非表示",
        "restore": "アセット復元",
        "save": "保存",
        "add": "キーバリューペアを追加",
        "addJson": "JSONオブジェクトを追加",
        "editJson": "JSONオブジェクトを編集",
        "saveJson": "JSONを保存",
        "advanceAddition": "高度な追加"
      },
      "detailsDialog": {
        "title": "アセット詳細"
      },
      "createDialog": {
        "title": {
          "general": "新規アセット作成",
          "edit": "アセット編集",
          "addProperties": "プロパティ追加",
          "advance": "高度なプロパティ追加"
        },
        "publicProps": "公開プロパティ",
        "privateProps": "非公開プロパティ",
        "dataAddress": "データアドレス",
        "dataSources": "データソース",
        "dataDestination": "データ送信先",
        "json": {
          "fields": "JSONフィールド",
          "editor": "カスタムプロパティエディタ",
          "formatted": "カスタムプロパティビューア",
          "error": "無効なJSON："
        },
        "fields": {
          "name": "名前",
          "namePlaceholder": "オファー名を入力",
          "id": "ID",
          "description": "説明",
          "contenttype": "コンテンツタイプ",
          "contenttypePlaceholder": "コンテンツタイプを入力",
          "contentType": "コンテンツタイプ",
          "contentTypePlaceholder": "コンテンツタイプを入力",
          "version": "バージョン",
          "keywords": "キーワード",
          "language": "言語",
          "languagePlaceholder": "言語を選択",
          "semanticId": "セマンティックID",
          "semanticIdPlaceholder": "セマンティックIDを入力",
          "dct:type": "dct:type",
          "dct:typePlaceholder": "dctタイプを選択",
          "keywordsPlaceholder": "キーワードを追加",
          "descriptionPlaceholder": "オファー説明を記述",
          "versionPlaceholder": "バージョン番号",
          "dataType": "データアドレスタイプ",
          "dataTypePlaceholder": "データアドレスタイプを選択",
          "dataAddressUrl": "アセットURL",
          "dataAddressUrlPlaceholder": "アセットURLを入力",
          "targetCompany": "対象企業",
          "targetCompanyPlaceholder": "対象企業を入力",
          "country": "国",
          "countryPlaceholder": "国を入力",
          "key": "キー",
          "keyPlaceholder": "キーを入力",
          "value": "値",
          "valuePlaceholder": "値を入力",
          "assetType": "アセットタイプ",
          "assetTypePlaceholder": "アセットタイプを入力"
        },
        "validation": {
          "name": "名前を入力してください",
          "assetType": "アセットタイプを選択してください",
          "contentType": "有効なコンテンツタイプを入力してください",
          "dataType": "有効なデータタイプを選択してください",
          "targetCompany": "有効な対象企業を入力してください",
          "country": "有効な国を入力してください"
        }
      },
      "tags": {
        "restricted": "アクセス制限",
        "unrestricted": "無制限"
      },
      "search": {
        "title": "検索フィルター",
        "helperText": "アセット名、作成日、またはタイプで検索",
        "filters": {
          "byName": "アセット名",
          "byType": "アセットタイプ",
          "byDate": "修正日"
        }
      },
      "delete": {
        "title": "アセット削除",
        "description": "このアセットを削除しますか？"
      }
    }
  },
  "home": {
    "title": "接続と統合"
  },
  "gettingStarted": {
    "title": "開始にヘルプが必要ですか？",
    "openWizard": "ウィザードを開く",
    "yourDataOffering": "あなたのデータオファー",
    "yourAssets": "アセット",
    "yourPolicies": "マイポリシー",
    "preconfiguredCatalogue": "事前設定カタログ",
    "contractAgreements": "契約合意",
    "incomingAgreements": "受信合意",
    "outgoingAgreements": "送信合意",
    "connectors": "あなたのコネクター",
    "providedAgreements": "提供契約合意",
    "consumedAgreements": "消費契約合意"
  },
  "yourConnection": {
    "title": "あなたのコネクター",
    "viewAllConnection": "すべてのコネクターを表示",
    "help": "ヘルプ",
    "documentation": "接続と統合について知る",
    "gettingStarted": "入門ガイド",
    "noUseCases": "利用可能なユースケースがありません"
  },
  "wizardSelectionPopup": {
    "whatToLike": "今日、どのようなことをしたい？",
    "prepare": "準備",
    "govern": "ガバナンス",
    "provide": "提供",
    "consume": "消費",
    "howToProvide": "今日、どのようにデータを提供したい？",
    "manual": "手動",
    "automated": "APIを介した自動化",
    "selectUseCases": "ユースケースを選択",
    "selectSingleUseCase": "ユースケースを選択",
    "selectDigitalTwin": "デジタルツインタイプを選択",
    "back": "戻る",
    "next": "次へ",
    "publish": "データスペースのフレームワーク要件を理解し、組織を代表してデータスペースでデータオファーを公開することに同意します。"
  },
  "createOffer": {
    "title": {
      "standard": "データオファー作成",
      "pcf": "PCFデータオファー作成",
      "certificate": "証明書オファーの作成"
    },
    "publish": "公開",
    "legalConfirmation": "データスペースのフレームワーク要件を理解し、組織を代表してデータスペースでデータオファーを公開することに同意します。",
    "wizard": {
      "provisionAsset": "アセット提供",
      "dataUpload": "データ選択",
      "attachPolicy": "ポリシー添付",
      "publishDataOffer": "データオファー公開"
    },
    "provisionAsset": {
      "howToSelectSubmodel": "どのサブモデルでデータオファーを作成したい？",
      "selectSubmodel": "サブモデルを選択",
      "selectUsecase": "ユースケースを選択",
      "selectDigitalTwinType": "デジタルツインタイプを選択",
      "whichTypeToSelect": "どのタイプを選ぶべき？",
      "generalInformation": "一般情報",
      "name": "名前",
      "id": "ID",
      "description": "説明",
      "contentType": "コンテンツタイプ",
      "version": "バージョン",
      "keywords": "キーワード",
      "language": "言語",
      "location": {
        "title": "位置とアドレス",
        "text": "アセットの詳細を入力してください"
      },
      "username": "ユーザー名",
      "password": "パスワード",
      "assetUrl": "アセットURL",
      "assetUrlPlaceHolder": "アセットURLを入力してください",
      "clientId": "クライアントID",
      "clientSecret": "クライアントシークレット",
      "tokenUrl": "トークンURL",
      "tokenUrlPlaceHolder": "トークンURLを入力してください",
      "provideAssets": "アセット提供",
      "selectConnectorLabel": "データを共有したいコネクターを選択",
      "selectConnectorPlaceholder": "コネクターを選択",
      "selectRestApiType": "REST-APIタイプを選択",
      "selectedAuthMethod": "認証方法"
    },
    "dataUpload": {
      "selectedDataModel": "データ選択",
      "csvUpload": {
        "title": "CSVファイル",
        "uploadFile": "ファイル選択",
        "uploadFileDescription": "交換したいファイルを準備してアップロード。Catena-Xに必要な形式を始めるためにサンプルファイルをダウンロードできます。",
        "uploadFileDescriptionNote1": "以下のリンクからテンプレートファイルをダウンロード",
        "uploadFileDescriptionNote2": "提供されたファイルにパートナーの詳細を入力",
        "uploadFileDescriptionNote3": "提供されたエリアにファイルをアップロード",
        "partnerValidationNote": "パートナー検証についてもっと知りたい場合は、",
        "clickHere": "こちらをクリック",
        "downloadTemplate": "テンプレートをダウンロード",
        "downloadSampleCsv": "サンプルCSVをダウンロード"
      },
      "jsonUpload": {
        "title": "JSON"
      },
      "tableUpload": {
        "title": "テーブル",
        "add": "追加"
      },
      "fileUpload": {
        "title": "ファイルアップロード",
        "description": "CSV、JSON"
      },
      "objectStorage": {
        "title": "オブジェクトストレージ",
        "description": "AWS、Azure、OTC、またはGCP"
      },
      "sftp": {
        "title": "SFTPサーバー",
        "description": "SFTPを介した転送"
      },
      "apiUpload": {
        "title": "REST API",
        "description": "APIを介した転送",
        "authAndIdentiTitle": "認証と識別",
        "authAndIdentiDesc": "送信先システムの認証詳細を入力してください",
        "selectApiType": "REST-APIタイプを選択",
        "locationAndAddrTitle": "位置とアドレス",
        "locationAndAddrDesc": "アセットの詳細を入力してください",
        "assetUrl": "アセットURL",
        "username": "ユーザー名",
        "password": "パスワード",
        "clientId": "クライアントID",
        "clientSecret": "クライアントシークレット"
      }
    },
    "fileUpload": {
      "title": "ここにファイルをドラッグ＆ドロップ",
      "btnText": "ファイル選択"
    },
    "attachPolicy": {
      "title": "このデータオファーにポリシーを添付",
      "createPolicy": "新しいポリシー作成",
      "bpnFieldTitle": "誰とデータを交換したい？",
      "howItWork": {
        "title": "どのように機能する？",
        "description": "Catena-Xユースケースフレームワーク合意に基づいてポリシーを事前設定。提供されたビジネスパートナーナンバーにのみデータアクセスが許可されます。",
        "knowMore": "ポリシーについてもっと知りたい？",
        "documentation": "ドキュメント"
      },
      "accessPolicyTableText": "このデータオファーにアクセスポリシーを添付",
      "usagePolicyTableText": "このデータオファーに使用ポリシーを添付",
      "heading": {
        "title": "既存ポリシーを添付または新規作成",
        "description": "データオファー公開を完了するには、以下のテーブルからアクセスおよび使用ポリシーを添付してください。ポリシー名でポリシーを検索したり、希望のポリシーがない場合は新しいポリシーを作成できます。"
      }
    },
    "publishDataOffer": {
      "dataOfferDetails": "データオファー詳細",
      "generalInformation": "一般情報",
      "attribute": "属性",
      "value": "値",
      "knowMore": "データオファーについてもっと知る",
      "attachedDataAssets": "添付アイテム",
      "attachedPolicies": "添付ポリシー",
      "allowPolicyPublish": "ポリシー公開を許可",
      "publish": "公開",
      "verifiedLegalEntity": "検証済み法人：",
      "dataOfferCreatedBy": "データオファー作成者：",
      "contactOrgAdmin": "組織管理者へ連絡",
      "help": "ヘルプ",
      "attachedDataAsset": "添付データアセット",
      "attachedAccessPolicy": "添付アクセスポリシー",
      "attachedUsagePolicy": "添付使用ポリシー",
      "publishedConnectors": "このオファーが公開されるコネクター",
      "knowMoreConnector": "コネクターについてもっと知る",
      "knowMorePolicies": "ポリシーについてもっと知る",
      "knowMoreDataAssets": "データアセットについてもっと知る",
      "knowMoreDataOffers": "データオファーについてもっと知る",
      "publishCheckboxLabel": "私は組織を代表して、データスペースでデータオファーとアセットを公開することに同意します。関連ポリシーを使用してデータスペースを管理し、関連ポリシーおよびデータスペースのフレームワークに従って公開後のオファーやアセットに関する操作を行います。"
    },
    "result": {
      "success": {
        "title": "リクエスト成功。",
        "description": "アセット公開プロセスが開始しました！ジョブIDは {id} です"
      }
    },
    "success": {
      "title": "データオファーが公開されました",
      "description": "データオファーが公開されました。次のステップについては以下をクリックしてください",
      "createOffer": "別のデータオファーを作成",
      "createOfferButton": "作成",
      "goToHome": "ホームに戻る",
      "goToHomeButton": "ホームに戻る",
      "uploadHistory": "アップロード履歴を確認"
    }
  },
  "policy": {
    "newPolicy": "新規ポリシー",
    "showDeletedPolicies": "削除済みポリシーを表示",
    "myDeletedPolicies": "マイ削除済みポリシー",
    "hideDeletedPolicies": "アクティブなポリシーを表示",
    "restoreAsset": "復元",
    "publishDeletion": "削除公開",
    "create": {
      "title": "新規ポリシー作成",
      "edit": "ポリシー編集",
      "policyName": "ポリシー名",
      "policyType": "{type} ポリシー",
      "accessPolicy": "アクセスポリシー",
      "usagePolicy": "使用ポリシー",
      "create": "作成して保存",
      "update": "更新"
    },
    "delete": {
      "title": "ポリシー削除",
      "description": "このポリシーを削除しますか？",
      "button": "削除"
    }
  },
  "jobs": {
    "jobs": "ジョブ",
    "id": "ID",
    "name": "名前",
    "startedAt": "開始日時",
    "status": "ステータス",
    "duration": "期間",
    "action": "アクション",
    "jobDetails": "処理詳細",
    "reload": "再読み込み",
    "noDetailsAvailable": "このジョブの詳細情報はありません",
    "retry": "再試行"
  },
  "search-offer": {
    "pageTitle": "データオファー検索",
    "pcfTitle": "PCFデータオファー検索",
    "certificateTitle": "ビジネスパートナーの証明書オファーを検索します",
    "filter": {
      "bpnSearch": "ビジネスパートナーナンバーまたは会社名で検索",
      "bpnSearchNote": "会社名またはBPNでデータオファーを検索。",
      "manufacturePartId": "製造者部品ID",
      "manufacturePartIdNote": "指定された部品IDに一致するすべてのデータオファーを検索。",
      "enter": "{field} を入力",
      "connectorUrl": "コネクターURL",
      "connectorUrlNote": "特定のコネクター内でデータを検索",
      "subModel": "サブモデル",
      "subModelNote": "希望するユースケースに合わせて検索結果を調整",
      "search": "検索",
      "searchBy": "検索条件",
      "resetFilters": "フィルターをリセット",
      "advancedSearch": "高度な検索",
      "name": "名前",
      "dct:type": "dct:type",
      "assetId": "アセットID"
    },
    "noResult": {
      "title": "結果なし",
      "description": "ネットワークで利用可能なデータオファーを閲覧するには検索してください"
    },
    "helpCard": {
      "title": "どのように機能する？",
      "description": "他のデータスペース参加者のデータオファーカタログを発見。データスペースで利用可能なデータオファーを検索、選択、購読できます。",
      "subtitle": "データオファー交渉と消費の仕組みについてもっと知りたい？",
      "documentation": "ドキュメント"
    },
    "offers": {
      "downloadSelected": "選択したものをダウンロード",
      "transferSelected": "選択したものを転送",
      "negotiate": "交渉",
      "noOffer": "データオファーがありません。"
    },
    "offer-details": {
      "title": "契約交渉の確認",
      "description": "説明",
      "details": "詳細",
      "attachedPolicies": "添付ポリシー",
      "termsCheck": "契約条件に同意し、契約交渉とデータ交換を開始します。",
      "negotiate": "交渉",
      "negotiateAndDownload": "交渉してダウンロード",
      "negotiateAndTransfer": "交渉して転送",
      "transfer": "転送",
      "cancel": "キャンセル",
      "attribute": "属性",
      "value": "値",
      "endpointUrl": "エンドポイントURL",
      "organization": "組織",
      "bpnNumber": "BPN番号",
      "manufacturerPartId": "製造者部品ID",
      "noOfAssets": "選択したアセット数",
      "membership": "メンバーシップ",
      "dismantlerBrands": "許可された解体ブランド",
      "frameworkAgreement": "フレームワーク合意",
      "dismantler": "解体者",
      "backToAssets": "アセットに戻る",
      "noPolicyMatchTitle": "アセット未交渉またはポリシーが一致しない",
      "noPolicyMatchText": "交渉されていないアセットをダウンロードしようとしています。あるいは、交渉しようとしているアセットのポリシーが一致しません。正しいアセットを選択して続行してください。",
      "negotiateInProgress": "交渉とダウンロードが進行中",
      "negotiateAndDownloadSuccess": "交渉とダウンロードが正常に完了",
      "negotiateAndTransferSuccess": "交渉と転送が正常に完了",
      "transferSuccess": "転送が正常に完了",
      "progress": "進捗",
      "fetchShell": "シェル取得",
      "exportToCSV": "CSVにエクスポート",
      "fetchJobFailed": "ジョブ詳細の取得中にエラー",
      "negotiateError": "アセットのダウンロード中にエラー",
      "dtr": "デジタルツインレジストリ",
      "edc": "コネクターアセット",
      "browseDtr": "DTRを閲覧"
    },
    "dtr": {
      "title": "デジタルツインシェル",
      "shells": "シェルを閲覧",
      "description": "選択したプロバイダのデジタルツインレジストリからシェルの取得とエクスポートを自動的に交渉します"
    }
  },
  "assetUploadHistory": {
    "title": "アセットアップロード履歴",
    "subtitle": "この履歴は、企業のデータスペースコネクターでのトランザクションの概要を示します。アセット、ポリシー、契約定義に関するすべての活動がここに一覧表示されます。",
    "refresh": "更新",
    "processId": "プロセスID",
    "providerUrl": "プロバイダURL",
    "createdOn": "作成日",
    "totalItems": "総アイテム",
    "successful": "成功",
    "failed": "失敗",
    "startDate": "開始日",
    "endDate": "終了日",
    "status": "ステータス",
    "actions": "アクション",
    "howItWork": {
      "title": "どのように機能する？",
      "description": "さまざまなデータスペースにわたるすべてのアップロードされたアセットの履歴を確認できます。ファイルをローカルに再ダウンロードしたり、外部の場所に転送できます。エラーが発生した場合は、ダウンロードを再試行するか、データオファーを再交渉する必要があります。",
      "moreInfo": "アップロード履歴やここでできることについてもっと知りたい？"
    }
  },
  "assetDownloadHistory": {
    "subtitle": "この履歴は、データスペースの交渉済み契約から組織がダウンロードしたデータの概要を提供します。必要に応じて、この履歴リストからデータを再度ダウンロードできます。",
    "howItWorks": {
      "description": "さまざまなデータスペースにわたるすべてのダウンロードされたアセットの履歴を確認できます。ファイルをローカルに再ダウンロードしたり、外部の場所に転送できます。エラーが発生した場合は、ダウンロードを再試行するか、データオファーを再交渉する必要があります。",
      "moreInfo": "ダウンロード履歴やここでできることについてもっと知りたい？"
    },
    "downloadError": "ダウンロードに失敗しました。もう一度お試しください！",
    "viewErrors": "エラーを表示"
  },
  "digitalTwinBrowser": {
    "subHeading": "これらはあなたのデジタルツインとそのサブモデルです。デジタルツインはデジタルツインレジストリを通じてデータスペースに公開されます。",
    "noDocumentError": "現在のIDにaspectDocumentがありません",
    "nameNotProvided": "名前が提供されていません",
    "fetchDigitalTwinsError": "デジタルツインの取得に失敗",
    "fetchAspectDocumentError": "アスペクトドキュメントの取得に失敗",
    "fetchAspectModelError": "アスペクトモデルの取得に失敗",
    "detailsOverviewModalTitle": "アスペクト詳細",
    "addItem": "アイテム追加",
    "detailsTable": {
      "id": "ID",
      "idShort": "短いID",
      "displayName": "表示名",
      "modelUrn": "モデルURN"
    },
    "shellsTable": {
      "id": "ID",
      "name": "名前",
      "manufacturer": "製造者部品ID",
      "modifiedBy": "ユーザー",
      "modifiedAt": "時間"
    }
  },
  "column": {
    "name": "名前",
    "contractId": "契約ID",
    "productId": "製品ID",
    "manufacturerPartId": "製造者部品ID",
    "manufacturerId": "製造者ID",
    "digitalTwinType": "デジタルツインタイプ",
    "correlationId": "相関ID",
    "requestId": "リクエストID",
    "bpn": "BPN",
    "createdAt": "作成日",
    "createdBy": "作成者",
    "actions": "アクション",
    "lastUpdatedTime": "最終更新日時",
    "status": "ステータス",
    "requestedDate": "リクエスト日",
    "policyType": "ポリシータイプ",
    "modifiedBy": "修正者",
    "modifiedOn": "修正日",
    "syncStatus": "同期ステータス",
    "assetId": "アセットID",
    "assetType": "アセットタイプ",
    "type": "タイプ",
    "createdFrom": "作成開始",
    "createdTo": "作成終了"
  },
  "messagesBrowser": {
    "fetchMessagesError": "メッセージの取得に失敗",
    "openRelatedMessage": "関連メッセージを開く",
    "messagesTable": {
      "id": "ID",
      "name": "名前",
      "createdAt": "作成日",
      "createdBy": "作成者",
      "type": "タイプ",
      "context": "コンテキスト",
      "senderBpn": "送信者BPN",
      "receiverBpn": "受信者BPN",
      "correlationId": "相関ID",
      "jobId": "ジョブID",
      "conversationId": "会話ID"
    },
    "messageType": {
      "ecu": "ECU",
      "generic": "一般",
      "quality": "品質"
    }
  }
}
